import React from "react";
import { Formik, Form, Field } from "formik";
import useFormCompany from "./useFormCompany";

const FormBasicInfo = ({
  onSubmit,
  setVroles,
  roles,
  setPage,
  page,
  vroles,
  data,
}) => {
  const [ companyData ] = data;
  const { validations, formSubmit} = useFormCompany(data, setPage)

  return (
    <Formik
      initialValues={companyData["basicInfo"]}
      onSubmit={formSubmit}
      validationSchema={validations}
    >
      {({ errors, touched, isSubmitting, handleChange }) => (
        <Form>
          <div className="form__wrapper">
            <div className="form__title text-center">Información Básica</div>

            <div className="form__row row">
              <div className="col-sm-12 col-md-8">
                <label htmlFor="nombre">Nombre de la Empresa</label>
                <Field
                  type="text"
                  name="companyName"
                  id="companyName"
                  required
                ></Field>
                {errors.companyName && touched.companyName && (
                  <span className="form__validation form__validation--error">
                    {errors.companyName}
                  </span>
                )}
                <span className="form__validation"></span>
              </div>

              <div className="col-sm-12 col-md-4">
                <label>Tipo de Perfil</label>
                <Field
                  as="select"
                  name="role"
                  value={vroles}
                  onChange={(event) => {
                    setVroles(event.target.value);
                    handleChange(event);
                  }}
                >
                  <option hidden>Selecione un perfil</option>
                  {roles.map((item, index) => {
                    return (
                      <option key={index} value={item.value}>
                        {item.desc}
                      </option>
                    );
                  })}
                  <option value="otro">Otro</option>
                </Field>
                {errors.role && touched.role && (
                  <span className="form__validation form__validation--error">
                    {errors.role}
                  </span>
                )}
              </div>
            </div>

            <div className="form__row row">
              <div className="col-sm-12 col-md-12">
                <label htmlFor="email">Siglas de la Empresa</label>
                <Field
                  type="text"
                  name="companyAcronym"
                  id="companyAcronym"
                ></Field>
              </div>
            </div>

            <div className="form__row row">
              <div className="col-sm-12 col-md-12">
                <label htmlFor="email">Nombre del Representante Legal</label>
                <Field
                  type="text"
                  name="legalRepresentativeName"
                  id="legalRepresentativeName"
                  required
                ></Field>
                {errors.legalRepresentativeName &&
                  touched.legalRepresentativeName && (
                    <span className="form__validation form__validation--error">
                      {errors.legalRepresentativeName}
                    </span>
                  )}
                <span className="form__validation"></span>
              </div>
              <div className="col-sm-12 col-md-4"></div>
            </div>

            <div className="form__row row">
              <div className="col-sm-12 col-md-12">
                <label htmlFor="email">Dirección de la Empresa</label>
                <Field
                  type="text"
                  name="companyAddress"
                  id="companyAddress"
                  required
                ></Field>
                {errors.companyAddress && touched.companyAddress && (
                  <span className="form__validation form__validation--error">
                    {errors.companyAddress}
                  </span>
                )}
                <span className="form__validation"></span>
              </div>
              <div className="col-sm-12 col-md-4"></div>
            </div>

            <div className="form__row row">
              <div className="col-sm-12 col-md-12">
                <label htmlFor="email">Correo Electrónico de la Empresa</label>
                <Field
                  type="email"
                  name="companyEmail"
                  id="companyEmail"
                  required
                ></Field>
                {errors.companyEmail && touched.companyEmail && (
                  <span className="form__validation form__validation--error">
                    {errors.companyEmail}
                  </span>
                )}
                <span className="form__validation"></span>
              </div>
              <div className="col-sm-12 col-md-4"></div>
            </div>

            <div className="form_row row">
              <div className="col-sm-12 col-md-6">
                <label htmlFor="telephone">Teléfono de la Empresa</label>
                <Field
                  type="tel"
                  name="companyPhone"
                  id="companyPhone"
                  required
                ></Field>
                {errors.companyPhone && touched.companyPhone && (
                  <span className="form__validation form__validation--error">
                    {errors.companyPhone}
                  </span>
                )}
                <span className="form__validation"></span>
              </div>

              <div className="col-sm-12 col-md-6">
                <label htmlFor="telephone">Celular de la Empresa</label>
                <Field
                  type="tel"
                  name="companyCellphone"
                  id="companyCellphone"
                  required
                ></Field>
                {errors.companyCellphone && touched.companyCellphone && (
                  <span className="form__validation form__validation--error">
                    {errors.companyCellphone}
                  </span>
                )}
                <span className="form__validation"></span>
              </div>
              <div className="col-sm-12 col-md-4 mb-2"></div>
            </div>

            <div className="form_row row">
              <div className="col-sm-12 col-md-12">
                <button
                  type="submit"
                  className="btn btn--gradient btn__icon btn__icon--door !bg-gradient-to-r from-[#9100ff] to-[#4b00ff]"
                >
                  Siguiente
                </button>
              </div>
              <div className="col-sm-12 col-md-4 mb-2"></div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default FormBasicInfo;
